import { nonAlphanumericRegex, nonNumericRegex } from "./constants.js";
const accountMessageDivId = "accountMessage";
function customerAccountValidationFailureMessage(message, isSuccess) {
    const errorMessageDivId = "accountMessage";
    toggleMessageValidation(errorMessageDivId, isSuccess, message);
}
export function deleteInvalidCharactersFromAccountNumber(accountNumber) {
    const accountNumberFormatRegex = /^[0-9]{10}/;
    if (accountNumberFormatRegex.test(accountNumber) && accountNumber.substring(10, 11).match("/")) {
        accountNumber = accountNumber.substring(0, 11) + accountNumber.substring(11, 16).replace(nonNumericRegex, "");
        accountNumber = accountNumber.substring(0, 12);
    }
    else {
        accountNumber = (accountNumber === null || accountNumber === void 0 ? void 0 : accountNumber.substring(0, 16).replace(nonAlphanumericRegex, "")) || "";
    }
    return accountNumber;
}
export function getOtpNumberIfValidOrNegative(otpSingleChar) {
    let otpValidNumber = -1;
    const otpChar0 = document.getElementById(otpSingleChar);
    if (!otpChar0 || otpChar0.value.length !== 1) {
        otpValidNumber = -1;
    }
    let pin = otpChar0.value.replace(nonAlphanumericRegex, "");
    if (/\d/.test(pin)) {
        otpValidNumber = Number(pin);
    }
    return otpValidNumber;
}
export function hideErrorDiv(div) {
    div.innerText = "";
    div.classList.add("hide");
    div.setAttribute("aria-live", "off");
}
export function hideSpinner(spinnerDiv) {
    spinnerDiv.classList.add("hide");
}
export function onErrorAction(message) {
    const spinnerDiv = document.getElementById("spinner");
    hideSpinner(spinnerDiv);
    customerAccountValidationFailureMessage(message, false);
}
export function showErrorDiv(div, message) {
    div.classList.remove("hide");
    div.innerText = message;
    div.setAttribute("aria-live", "assertive");
}
export function showSpinner(spinnerDiv) {
    spinnerDiv.classList.remove("hide");
}
export function toggleAccountNumberValidationMessage(accountNumberTextBox, isAccountNumberValid) {
    const accountErrorMessageDiv = document.getElementById(accountMessageDivId);
    if (isAccountNumberValid) {
        hideErrorDiv(accountErrorMessageDiv);
        toggleMessageValidation(accountMessageDivId, isAccountNumberValid, " Please click next to continue.");
    }
    else {
        const accountNumberLengthMessage = "Account number must be at least 7 characters long.";
        const accountNumberRequiredMessage = "Billing account number is required.";
        let message;
        if (accountNumberTextBox.validity.valueMissing) {
            message = accountNumberRequiredMessage;
        }
        else if (accountNumberTextBox.validity.patternMismatch) {
            message = accountNumberLengthMessage;
        }
        else {
            message = "";
        }
        toggleMessageValidation(accountMessageDivId, isAccountNumberValid, message);
    }
    accountNumberTextBox.setAttribute("aria-invalid", isAccountNumberValid ? "false" : "true");
}
export function toggleMessageValidation(divElementId, isSuccess, message) {
    const messageDiv = document.getElementById(divElementId);
    if (!messageDiv) {
        return;
    }
    if (message.trim().length === 0) {
        messageDiv.classList.add("hide");
        return;
    }
    messageDiv.innerText = message;
    messageDiv.classList.remove("hide", "center", "onSuccessMessage", "onSuccess", "onErrorMessage");
    if (isSuccess) {
        messageDiv.classList.add("onSuccessMessage");
        if (message.toLowerCase().indexOf("please click next to continue")) {
            messageDiv.classList.add("onSuccess");
        }
    }
    else {
        messageDiv.classList.add("onErrorMessage", "center");
    }
}
export function toggleEmailPhoneValidationMessage() {
    let errorMessageDiv = document.getElementById("errMessage");
    const email = document.getElementById("email");
    const mobile = document.getElementById("mobile");
    let emailMobileRequiredMessage = "";
    let isValid = false;
    if (email != null && mobile != null && (email.checked || mobile.checked)) {
        hideErrorDiv(errorMessageDiv);
        isValid = true;
    }
    else {
        emailMobileRequiredMessage = "Please select Email or Mobile phone to verify your account.";
    }
    showErrorDiv(errorMessageDiv, emailMobileRequiredMessage);
    return isValid;
}
export function toggleOtpValidationMessage() {
    let isValid = false;
    const pinErrorMessageDiv = document.getElementById("errMessage");
    const otpChar0 = document.getElementById("otpChar0").value;
    const otpChar1 = document.getElementById("otpChar1").value;
    const otpChar2 = document.getElementById("otpChar2").value;
    const otpChar3 = document.getElementById("otpChar3").value;
    const otpChar4 = document.getElementById("otpChar4").value;
    const otpChar5 = document.getElementById("otpChar5").value;
    if (otpChar0 != "" && otpChar1 != "" && otpChar2 != "" && otpChar3 != "" && otpChar4 != "" && otpChar5 != "") {
        isValid = true;
        hideErrorDiv(pinErrorMessageDiv);
    }
    else {
        const pinRequiredMessage = "6-digit code is required.";
        showErrorDiv(pinErrorMessageDiv, pinRequiredMessage);
    }
    return isValid;
}
export function togglePinAuthMethodValidationMessage() {
    let isValid = false;
    const pinErrorMessageDiv = document.getElementById("errMessage");
    const pinChar0 = document.getElementById("pinChar0").value;
    const pinChar1 = document.getElementById("pinChar1").value;
    const pinChar2 = document.getElementById("pinChar2").value;
    const pinChar3 = document.getElementById("pinChar3").value;
    if (pinChar0 != "" && pinChar1 != "" && pinChar2 != "" && pinChar3 != "") {
        isValid = true;
        hideErrorDiv(pinErrorMessageDiv);
    }
    else {
        const pinRequiredMessage = "4-digit PIN is required.";
        showErrorDiv(pinErrorMessageDiv, pinRequiredMessage);
    }
    return isValid;
}
export function togglePinValidationMessage(pinTextBox, isPinValid) {
    const pinErrorMessageDiv = document.getElementById("pinErrorMessage");
    if (isPinValid) {
        hideErrorDiv(pinErrorMessageDiv);
    }
    else {
        const pinRequiredMessage = "4-digit PIN is required.";
        showErrorDiv(pinErrorMessageDiv, pinRequiredMessage);
    }
    pinTextBox.setAttribute("aria-invalid", isPinValid ? "false" : "true");
}
export function toggleUpdateNextToTryAgainandNextButton() {
    var _a, _b;
    const otpSignIn = document.getElementById("otp-signIn");
    if (otpSignIn) {
        if (((_a = otpSignIn.textContent) === null || _a === void 0 ? void 0 : _a.trim().toLowerCase()) === "next") {
            otpSignIn.textContent = "Try Again";
            otpSignIn.title = "Try Again";
            const accountNumberTextBox = document.getElementById("accountNumberTextBox");
            if (accountNumberTextBox) {
                accountNumberTextBox.disabled = true;
            }
        }
        else if (((_b = otpSignIn.textContent) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === "try again") {
            otpSignIn.textContent = "Next";
            const accountNumberTextBox = document.getElementById("accountNumberTextBox");
            if (accountNumberTextBox) {
                accountNumberTextBox.disabled = true;
            }
        }
    }
}
//# sourceMappingURL=ui.js.map